<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">密码修改</span>
            </div>
            <div class="box-cont">
                <el-form :model="form" ref="form" :rules="rules" label-width="140px">
                    <el-form-item label="用户代码:" prop="dm">
                        <el-input disabled style="width:300px;"
                        v-model="form.dm"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                    <el-form-item label="新密码:" prop="mm1">
                        <el-input style="width:300px;"
                        v-model="form.mm1"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                    <el-form-item label="确认密码:" prop="mm2">
                        <el-input style="width:300px;"
                        v-model="form.mm2"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submit('form')">确认</el-button>
                        <el-button type="info" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            form:{
                dm:'',
                mm1:'',
                mm2:''
            },
            rules:{
                dm: [
                    { required: true, message: '用户编码不能为空', trigger: 'blur' }
                ],
                mm1: [
                    { required: true, message: '新密码不能为空', trigger: 'blur' }
                ],
                mm2: [
                    { required: true, message: '确认密码不能为空', trigger: 'blur' }
                ],
            },
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.form.dm = user.dm
        this.baseUrl = user.baseUrl
    },
    methods: {
        submit(form){
            if (this.form.mm1 != this.form.mm2) {
                this.$message({
                message: "新密码与确认新密码输入的不一致!!!",
                type: "warning"
                });
                return
            }
            this.$refs[form].validate((valid) => {
                if (valid) {
                    axios({
                        method: 'post',
                        url: this.baseUrl+`/login/editPsW`,
                        data:{
                            dm: this.form.dm,
                            mm: this.form.mm1
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        if(res.data.code == 0){
                            this.$message({
                                message: "修改成功，请重新登录",
                                type: "success"
                            });
                            this.$router.push({
                                path: "/login"
                            });
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }
                        }
                    }).catch(error => {
                        this.$message.error(error);
                    })
                    
                }
            })
        },
        resetQuery(){
            this.form.mm1 = ''
            this.form.mm2 = ''
        },
    }
}
</script>


<style scoped>
</style>